import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

export const validateNumber = (value: string) => {
  if (Number(value) < 0) {
    return { color: '#94C947', backgroundColor: '#94c94747' };
  }
  return {};
};

const AmountColumn: FC<GridCellProps> = (props) => {
  const { displayValue, value } = useGridCellDisplayValue(props);
  return (
    <GridCellBase {...props} style={validateNumber(value)}>
      {displayValue}
    </GridCellBase>
  );
};

export default AmountColumn;
